import hireSowosModerateTypes from './hire/types';

export default {
  ...hireSowosModerateTypes,
};
